import { createStrictContext } from 'utils/createContext'
import { IFINotificationsContext } from './types'
import { useIfiNotificationsQuery } from 'schema'
import { DefaultQueryHookOptions } from 'utils/defaults'
import { useRecipientsFn } from 'components/CIMSNotifications/hooks/useRecipientsFn'
import { useProjectContext } from 'context/ProjectContext'

const { Provider, useContextFn } = createStrictContext<IFINotificationsContext>(
  'IFINotificationsContext'
)
export const useIFINotificationsContext = useContextFn

const IFINotificationsProvider: React.FC = ({ children }) => {
  const { projectId } = useProjectContext()
  const { data, loading, refetch } = useIfiNotificationsQuery({
    ...DefaultQueryHookOptions,
    variables: { projectId },
  })
  const recipients = useRecipientsFn({
    data,
    getter: (id, { ifiNotifications }) =>
      ifiNotifications.records.find(
        ({ notificationEventId }) => notificationEventId === id
      )?.recipients,
    fallback: {
      __typename: 'IFINotificationRecipients',
      every: null,
      asphaltLot: null,
      concreteTest: null,
      dailyInspectionControlPoint: null,
      dailyInspectionInspection: null,
      dailyInspectionPunchList: null,
      densityLot: null,
      densityTest: null,
    },
  })
  return (
    <Provider
      value={{
        loading,
        refetch,
        notifications: data?.ifiNotifications.records ?? [],
        recipients,
      }}
    >
      {children}
    </Provider>
  )
}

export default IFINotificationsProvider
